import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
request.get('/api/v4ward/warehouse/dept/stock/page', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
request.get('/api/v4ward/custom/form/main/detail', Object.assign({}, options, { params }))

// 获取未用物资数量总和
export const getSummary = (params, options) =>
request.get('/api/v4ward/warehouse/dept/stock/getNumSum', Object.assign({}, options, { params }))

export const update = (params, options) =>
request.post('/api/v4ward/custom/form/main/submit', params,options)

// v4ward/warehouse/dept/stock/export

// 导出
export const exportE = (params, options) =>
request.post('/api/v4ward/warehouse/dept/stock/export', params,options)

